import { Merchant } from './merchant-details.model';

export interface MerchantDetailsState {
	/**
	 * If we're loading the merchant details
	 */
	loading: boolean;
	/**
	 * If the merchant details loaded correctly.
	 */
	loaded: boolean;
	/**
	 * If there was an error loading.
	 */
	errorLoading: boolean;
	/**
	 * The actual merchant details for the merchant the application is configured in
	 */
	merchant: Merchant;
	/**
	 * The default language
	 */
	defaultLanguage: string;
	/**
	 * If merchant the application is configured in is different than the merchant the order was placed with,
	 * getMerchantDetails will be called again, and returned information will be stored in orderMerchant
	 * If not, this property will not be created
	 * The merchant details for the merchant the order was placed with
	 */
	orderMerchant?: Merchant;
}

export const initialState: MerchantDetailsState = {
	loaded: false,
	loading: false,
	errorLoading: false,
	merchant: null,
	defaultLanguage: null,
};
